import { useCallback, useMemo } from "react";
import * as R from "ramda";

const getTargetOrigin = (intCtx) => {
  try {
    return intCtx ? new URL(intCtx).origin : "*";
  } catch {
    return "*";
  }
};

export const usePostMessage = (flow, intCtx) => {
  const lFlow = useMemo(() => R.toLower(R.defaultTo("", flow)), [flow]);
  const targetOrigin = useMemo(() => getTargetOrigin(intCtx), [intCtx]);
  const postMessage = useCallback((event, data = {}) => {
    const payload = { source: "tilia", event, ...data };
    window.parent.postMessage(payload, targetOrigin);
  }, [targetOrigin]);

  /**
   * postOnComplete
   * @type {OnComplete}
   */
  const postOnComplete = useCallback(
    (data) => {
      postMessage(`tilia.${lFlow}.complete`, data);
      return "post-receipt";
    },
    [lFlow, postMessage]
  );

  /**
   * postOnReady
   * @type {OnReady}
   */
  const postOnReady = useCallback(
    (data) => {
      postMessage(`tilia.${lFlow}.ready`, data);
    },
    [lFlow, postMessage]
  );

  /**
   * postOnCancel
   * @type {OnCancel}
   */
  const postOnCancel = useCallback(
    (data) => {
      postMessage(`tilia.${lFlow}.cancel`, data);
    },
    [lFlow, postMessage]
  );

  /**
   * postOnError
   * @type {OnError}
   */
  const postOnError = useCallback(
    (data) => {
      const cleanedData = JSON.parse(JSON.stringify(data)); // if we're passing through error objects, some of those can functions that trigger clone errors.  Sending to json and back can tidy it up.
      postMessage(`tilia.${lFlow}.error`, cleanedData);
    },
    [lFlow, postMessage]
  );

  /**
   * postOnEvent
   * @type {OnEvent}
   */
  const postOnEvent = useCallback(
    (data) => {
      postMessage(`tilia.${lFlow}.event`, data);
    },
    [lFlow, postMessage]
  );

  /**
   * postOnUpdate
   * @type {OnUpdate}
   */
   const postOnUpdate = useCallback(
    (data) => {
      postMessage(`tilia.${lFlow}.update`, data);
    },
    [lFlow, postMessage]
  );

  return { postMessage, postOnComplete, postOnReady, postOnCancel, postOnError, postOnEvent, postOnUpdate };
};
